/** Auto-generated card WebP requires — do not edit by hand. */
export const DISH_CARD_IMAGES: Record<string, number> = {
  'moong-dal-khichdi': require('../../assets/dishes/card/moong-dal-khichdi.webp'),
  'masala-khichdi': require('../../assets/dishes/card/masala-khichdi.webp'),
  'palak-khichdi': require('../../assets/dishes/card/palak-khichdi.webp'),
  'veg-pulao': require('../../assets/dishes/card/veg-pulao.webp'),
  'veg-tehri': require('../../assets/dishes/card/veg-tehri.webp'),
  'lemon-rice': require('../../assets/dishes/card/lemon-rice.webp'),
  'tomato-rice': require('../../assets/dishes/card/tomato-rice.webp'),
  'curd-rice': require('../../assets/dishes/card/curd-rice.webp'),
  'bisi-bele-bath': require('../../assets/dishes/card/bisi-bele-bath.webp'),
  'dal-tadka': require('../../assets/dishes/card/dal-tadka.webp'),
  'toor-dal-fry': require('../../assets/dishes/card/toor-dal-fry.webp'),
  'panchmel-dal': require('../../assets/dishes/card/panchmel-dal.webp'),
  'chana-masala': require('../../assets/dishes/card/chana-masala.webp'),
  'rajma-masala': require('../../assets/dishes/card/rajma-masala.webp'),
  'lobia-masala': require('../../assets/dishes/card/lobia-masala.webp'),
  'aloo-gobi-dry': require('../../assets/dishes/card/aloo-gobi-dry.webp'),
  'aloo-matar-gravy': require('../../assets/dishes/card/aloo-matar-gravy.webp'),
  'aloo-methi': require('../../assets/dishes/card/aloo-methi.webp'),
  'aloo-shimla-mirch': require('../../assets/dishes/card/aloo-shimla-mirch.webp'),
  'aloo-patta-gobi': require('../../assets/dishes/card/aloo-patta-gobi.webp'),
  'bhindi-masala': require('../../assets/dishes/card/bhindi-masala.webp'),
  'bhindi-fry': require('../../assets/dishes/card/bhindi-fry.webp'),
  'lauki-sabzi': require('../../assets/dishes/card/lauki-sabzi.webp'),
  'jeera-aloo': require('../../assets/dishes/card/jeera-aloo.webp'),
  'baingan-bharta': require('../../assets/dishes/card/baingan-bharta.webp'),
  'baingan-aloo-sabzi': require('../../assets/dishes/card/baingan-aloo-sabzi.webp'),
  'turai-sabzi': require('../../assets/dishes/card/turai-sabzi.webp'),
  'veg-kolhapuri': require('../../assets/dishes/card/veg-kolhapuri.webp'),
  'veg-kurma': require('../../assets/dishes/card/veg-kurma.webp'),
  'mixed-veg-sambar': require('../../assets/dishes/card/mixed-veg-sambar.webp'),
  'tomato-rasam': require('../../assets/dishes/card/tomato-rasam.webp'),
  'kadai-paneer': require('../../assets/dishes/card/kadai-paneer.webp'),
  'palak-paneer': require('../../assets/dishes/card/palak-paneer.webp'),
  'matar-paneer': require('../../assets/dishes/card/matar-paneer.webp'),
  'paneer-bhurji': require('../../assets/dishes/card/paneer-bhurji.webp'),
  'paneer-butter-masala': require('../../assets/dishes/card/paneer-butter-masala.webp'),
  'kadai-tofu': require('../../assets/dishes/card/kadai-tofu.webp'),
  'dum-aloo': require('../../assets/dishes/card/dum-aloo.webp'),
  'home-style-chicken-curry': require('../../assets/dishes/card/home-style-chicken-curry.webp'),
  'egg-curry': require('../../assets/dishes/card/egg-curry.webp'),
  'egg-bhurji': require('../../assets/dishes/card/egg-bhurji.webp'),
  'plain-yellow-moong-dal': require('../../assets/dishes/card/plain-yellow-moong-dal.webp'),
  'punjabi-kadhi': require('../../assets/dishes/card/punjabi-kadhi.webp'),
  'tariwale-aloo': require('../../assets/dishes/card/tariwale-aloo.webp'),
  'dahi-aloo': require('../../assets/dishes/card/dahi-aloo.webp'),
  'besan-chilla': require('../../assets/dishes/card/besan-chilla.webp'),
  'oats-chilla': require('../../assets/dishes/card/oats-chilla.webp'),
  'jeera-ajwain-paratha': require('../../assets/dishes/card/jeera-ajwain-paratha.webp'),
  'egg-bhurji-sandwich': require('../../assets/dishes/card/egg-bhurji-sandwich.webp'),
  'sukhi-moong-dal': require('../../assets/dishes/card/sukhi-moong-dal.webp'),
  'sabudana-khichdi-dinner': require('../../assets/dishes/card/sabudana-khichdi-dinner.webp'),
  'dal-makhani': require('../../assets/dishes/card/dal-makhani.webp'),
  'chicken-biryani': require('../../assets/dishes/card/chicken-biryani.webp'),
  'veg-biryani': require('../../assets/dishes/card/veg-biryani.webp'),
  'malai-kofta': require('../../assets/dishes/card/malai-kofta.webp'),
  'chicken-fried-rice': require('../../assets/dishes/card/chicken-fried-rice.webp'),
  'veg-fried-rice': require('../../assets/dishes/card/veg-fried-rice.webp'),
  'veg-hakka-noodles': require('../../assets/dishes/card/veg-hakka-noodles.webp'),
  'white-sauce-pasta': require('../../assets/dishes/card/white-sauce-pasta.webp'),
  'red-sauce-pasta': require('../../assets/dishes/card/red-sauce-pasta.webp'),
  'veg-grilled-sandwich': require('../../assets/dishes/card/veg-grilled-sandwich.webp'),
  'veg-cheese-burger': require('../../assets/dishes/card/veg-cheese-burger.webp'),
  'chilli-paneer': require('../../assets/dishes/card/chilli-paneer.webp'),
  poha: require('../../assets/dishes/card/poha.webp'),
  'rava-upma': require('../../assets/dishes/card/rava-upma.webp'),
  'semiya-upma': require('../../assets/dishes/card/semiya-upma.webp'),
  'plain-idli': require('../../assets/dishes/card/plain-idli.webp'),
  'plain-dosa': require('../../assets/dishes/card/plain-dosa.webp'),
  'masala-dosa': require('../../assets/dishes/card/masala-dosa.webp'),
  uttapam: require('../../assets/dishes/card/uttapam.webp'),
  'methi-thepla': require('../../assets/dishes/card/methi-thepla.webp'),
  'aloo-paratha': require('../../assets/dishes/card/aloo-paratha.webp'),
  'paneer-paratha': require('../../assets/dishes/card/paneer-paratha.webp'),
  'sabudana-khichdi': require('../../assets/dishes/card/sabudana-khichdi.webp'),
  'bread-omelette': require('../../assets/dishes/card/bread-omelette.webp'),
  'khaman-dhokla': require('../../assets/dishes/card/khaman-dhokla.webp'),
  'pav-bhaji': require('../../assets/dishes/card/pav-bhaji.webp'),
  'veg-cutlet': require('../../assets/dishes/card/veg-cutlet.webp'),
  'gajar-halwa': require('../../assets/dishes/card/gajar-halwa.webp'),
  'rice-kheer': require('../../assets/dishes/card/rice-kheer.webp'),
  shrikhand: require('../../assets/dishes/card/shrikhand.webp'),
  'gulab-jamun': require('../../assets/dishes/card/gulab-jamun.webp'),
  'aloo-beans-sabzi': require('../../assets/dishes/card/aloo-beans-sabzi.webp'),
  'aloo-palak-sabzi': require('../../assets/dishes/card/aloo-palak-sabzi.webp'),
  'aloo-soya-sabzi': require('../../assets/dishes/card/aloo-soya-sabzi.webp'),
  'aloo-gajar-matar': require('../../assets/dishes/card/aloo-gajar-matar.webp'),
  'gobi-matar': require('../../assets/dishes/card/gobi-matar.webp'),
  'gobi-masala': require('../../assets/dishes/card/gobi-masala.webp'),
  'baingan-curry': require('../../assets/dishes/card/baingan-curry.webp'),
  'bharli-vangi': require('../../assets/dishes/card/bharli-vangi.webp'),
  ennegai: require('../../assets/dishes/card/ennegai.webp'),
  'bharwa-baingan': require('../../assets/dishes/card/bharwa-baingan.webp'),
  'lauki-chana-dal': require('../../assets/dishes/card/lauki-chana-dal.webp'),
  'lauki-kofta': require('../../assets/dishes/card/lauki-kofta.webp'),
  'tinda-sabzi': require('../../assets/dishes/card/tinda-sabzi.webp'),
  'parwal-sabzi': require('../../assets/dishes/card/parwal-sabzi.webp'),
  'bharwa-parwal': require('../../assets/dishes/card/bharwa-parwal.webp'),
  'tindora-sabzi': require('../../assets/dishes/card/tindora-sabzi.webp'),
  'karela-sabzi': require('../../assets/dishes/card/karela-sabzi.webp'),
  'karela-pyaz': require('../../assets/dishes/card/karela-pyaz.webp'),
  'bharwa-karela': require('../../assets/dishes/card/bharwa-karela.webp'),
  'khatta-meetha-kaddu': require('../../assets/dishes/card/khatta-meetha-kaddu.webp'),
  'petha-sabzi': require('../../assets/dishes/card/petha-sabzi.webp'),
  'cabbage-peas-sabzi': require('../../assets/dishes/card/cabbage-peas-sabzi.webp'),
  'cabbage-carrot-sabzi': require('../../assets/dishes/card/cabbage-carrot-sabzi.webp'),
  'carrot-beans-poriyal': require('../../assets/dishes/card/carrot-beans-poriyal.webp'),
  'beans-aloo-sabzi': require('../../assets/dishes/card/beans-aloo-sabzi.webp'),
  'french-beans-dry': require('../../assets/dishes/card/french-beans-dry.webp'),
  'cluster-beans-sabzi': require('../../assets/dishes/card/cluster-beans-sabzi.webp'),
  'green-peas-masala': require('../../assets/dishes/card/green-peas-masala.webp'),
  'besan-capsicum': require('../../assets/dishes/card/besan-capsicum.webp'),
  'bharwa-shimla-mirch': require('../../assets/dishes/card/bharwa-shimla-mirch.webp'),
  'methi-matar-malai': require('../../assets/dishes/card/methi-matar-malai.webp'),
  'methi-mutter': require('../../assets/dishes/card/methi-mutter.webp'),
  'mushroom-masala': require('../../assets/dishes/card/mushroom-masala.webp'),
  'mushroom-matar': require('../../assets/dishes/card/mushroom-matar.webp'),
  'kadai-mushroom': require('../../assets/dishes/card/kadai-mushroom.webp'),
  'palak-corn': require('../../assets/dishes/card/palak-corn.webp'),
  'sarson-ka-saag': require('../../assets/dishes/card/sarson-ka-saag.webp'),
  'mixed-greens-saag': require('../../assets/dishes/card/mixed-greens-saag.webp'),
  'mooli-sabzi': require('../../assets/dishes/card/mooli-sabzi.webp'),
  'mooli-mutter': require('../../assets/dishes/card/mooli-mutter.webp'),
  'arbi-masala': require('../../assets/dishes/card/arbi-masala.webp'),
  'arbi-fry': require('../../assets/dishes/card/arbi-fry.webp'),
  'sukhi-arbi': require('../../assets/dishes/card/sukhi-arbi.webp'),
  'suran-sabzi': require('../../assets/dishes/card/suran-sabzi.webp'),
  'jimikand-masala': require('../../assets/dishes/card/jimikand-masala.webp'),
  'kacche-kele-ki-sabzi': require('../../assets/dishes/card/kacche-kele-ki-sabzi.webp'),
  'raw-banana-kofta': require('../../assets/dishes/card/raw-banana-kofta.webp'),
  'shakarkandi-sabzi': require('../../assets/dishes/card/shakarkandi-sabzi.webp'),
  'kathal-masala': require('../../assets/dishes/card/kathal-masala.webp'),
  'tamatar-ki-sabzi': require('../../assets/dishes/card/tamatar-ki-sabzi.webp'),
  'tomato-curry': require('../../assets/dishes/card/tomato-curry.webp'),
  'pyaz-ki-sabzi': require('../../assets/dishes/card/pyaz-ki-sabzi.webp'),
  'bharwa-bhindi': require('../../assets/dishes/card/bharwa-bhindi.webp'),
  'cabbage-kofta': require('../../assets/dishes/card/cabbage-kofta.webp'),
  'mixed-veg-kofta': require('../../assets/dishes/card/mixed-veg-kofta.webp'),
  'mix-veg-sabzi': require('../../assets/dishes/card/mix-veg-sabzi.webp'),
  'sukhi-mixed-veg': require('../../assets/dishes/card/sukhi-mixed-veg.webp'),
  'veg-jalfrezi': require('../../assets/dishes/card/veg-jalfrezi.webp'),
  'veg-handi': require('../../assets/dishes/card/veg-handi.webp'),
  'hyderabadi-veg': require('../../assets/dishes/card/hyderabadi-veg.webp'),
  'navratan-korma': require('../../assets/dishes/card/navratan-korma.webp'),
  undhiyu: require('../../assets/dishes/card/undhiyu.webp'),
  'sev-tameta': require('../../assets/dishes/card/sev-tameta.webp'),
  'ringan-bateta': require('../../assets/dishes/card/ringan-bateta.webp'),
  'batata-bhaji': require('../../assets/dishes/card/batata-bhaji.webp'),
  'kobi-batata': require('../../assets/dishes/card/kobi-batata.webp'),
  'sai-bhaji': require('../../assets/dishes/card/sai-bhaji.webp'),
  'aloo-baingan-tamatar': require('../../assets/dishes/card/aloo-baingan-tamatar.webp'),
  'gobi-aloo-matar': require('../../assets/dishes/card/gobi-aloo-matar.webp'),
  'palak-aloo-matar': require('../../assets/dishes/card/palak-aloo-matar.webp'),
  'gobi-capsicum': require('../../assets/dishes/card/gobi-capsicum.webp'),
  'matar-mushroom-masala': require('../../assets/dishes/card/matar-mushroom-masala.webp'),
  'corn-capsicum-sabzi': require('../../assets/dishes/card/corn-capsicum-sabzi.webp'),
  'baby-corn-masala': require('../../assets/dishes/card/baby-corn-masala.webp'),
  'aloo-simla-matar': require('../../assets/dishes/card/aloo-simla-matar.webp'),
  'turai-chana-dal': require('../../assets/dishes/card/turai-chana-dal.webp'),
  'capsicum-besan-masala': require('../../assets/dishes/card/capsicum-besan-masala.webp'),
  'chana-aloo-rasedar': require('../../assets/dishes/card/chana-aloo-rasedar.webp'),
  'sem-ki-sabzi': require('../../assets/dishes/card/sem-ki-sabzi.webp'),
  'chana-saag': require('../../assets/dishes/card/chana-saag.webp'),
  'kaddu-chana-dal': require('../../assets/dishes/card/kaddu-chana-dal.webp'),
  'paneer-jalfrezi': require('../../assets/dishes/card/paneer-jalfrezi.webp'),
  'gajar-matar-aloo': require('../../assets/dishes/card/gajar-matar-aloo.webp'),
  'surti-papdi-nu-shaak': require('../../assets/dishes/card/surti-papdi-nu-shaak.webp'),
  'bhindi-do-pyaza': require('../../assets/dishes/card/bhindi-do-pyaza.webp'),
  'aloo-gobi-gravy': require('../../assets/dishes/card/aloo-gobi-gravy.webp'),
  'matar-paneer-dry': require('../../assets/dishes/card/matar-paneer-dry.webp'),
  'aloo-tinda': require('../../assets/dishes/card/aloo-tinda.webp'),
  'vendakkai-poriyal': require('../../assets/dishes/card/vendakkai-poriyal.webp'),
  'cabbage-poriyal': require('../../assets/dishes/card/cabbage-poriyal.webp'),
  'beetroot-poriyal': require('../../assets/dishes/card/beetroot-poriyal.webp'),
  avial: require('../../assets/dishes/card/avial.webp'),
  'vegetable-stew': require('../../assets/dishes/card/vegetable-stew.webp'),
  'beetroot-sabzi': require('../../assets/dishes/card/beetroot-sabzi.webp'),
  'lauki-tamatar': require('../../assets/dishes/card/lauki-tamatar.webp'),
  'baingan-tamatar': require('../../assets/dishes/card/baingan-tamatar.webp'),
  'chana-dal-lauki-koftas': require('../../assets/dishes/card/chana-dal-lauki-koftas.webp'),
  'methi-aloo-matar': require('../../assets/dishes/card/methi-aloo-matar.webp'),
  'kathal-dry-fry': require('../../assets/dishes/card/kathal-dry-fry.webp'),
  'mushroom-do-pyaza': require('../../assets/dishes/card/mushroom-do-pyaza.webp'),
  'aloo-arbi': require('../../assets/dishes/card/aloo-arbi.webp'),
  'kachumber-aloo-rasa': require('../../assets/dishes/card/kachumber-aloo-rasa.webp'),
  'matar-aloo-rasedar': require('../../assets/dishes/card/matar-aloo-rasedar.webp'),
  'vegetable-makhanwala': require('../../assets/dishes/card/vegetable-makhanwala.webp'),
  'capsicum-aloo-besan': require('../../assets/dishes/card/capsicum-aloo-besan.webp'),
  'vatana-bateta': require('../../assets/dishes/card/vatana-bateta.webp'),
  'flower-bateta': require('../../assets/dishes/card/flower-bateta.webp'),
  'masala-karela-pyaz': require('../../assets/dishes/card/masala-karela-pyaz.webp'),
  'corn-palak': require('../../assets/dishes/card/corn-palak.webp'),
  'soya-matar': require('../../assets/dishes/card/soya-matar.webp'),
  'bharwa-tinda': require('../../assets/dishes/card/bharwa-tinda.webp'),
  'dahi-bhindi': require('../../assets/dishes/card/dahi-bhindi.webp'),
  'achari-aloo': require('../../assets/dishes/card/achari-aloo.webp'),
  'zucchini-sabzi': require('../../assets/dishes/card/zucchini-sabzi.webp'),
  'drumstick-sambar': require('../../assets/dishes/card/drumstick-sambar.webp'),
  'arachuvitta-sambar': require('../../assets/dishes/card/arachuvitta-sambar.webp'),
  'udupi-sambar': require('../../assets/dishes/card/udupi-sambar.webp'),
  'vengaya-sambar': require('../../assets/dishes/card/vengaya-sambar.webp'),
  'radish-sambar': require('../../assets/dishes/card/radish-sambar.webp'),
  'brinjal-sambar': require('../../assets/dishes/card/brinjal-sambar.webp'),
  'ladies-finger-sambar': require('../../assets/dishes/card/ladies-finger-sambar.webp'),
  'milagu-rasam': require('../../assets/dishes/card/milagu-rasam.webp'),
  'poondu-rasam': require('../../assets/dishes/card/poondu-rasam.webp'),
  'lemon-rasam': require('../../assets/dishes/card/lemon-rasam.webp'),
  'jeera-rasam': require('../../assets/dishes/card/jeera-rasam.webp'),
  'paruppu-rasam': require('../../assets/dishes/card/paruppu-rasam.webp'),
  'mysore-rasam': require('../../assets/dishes/card/mysore-rasam.webp'),
  'vatha-kuzhambu': require('../../assets/dishes/card/vatha-kuzhambu.webp'),
  'puli-kuzhambu': require('../../assets/dishes/card/puli-kuzhambu.webp'),
  'kara-kuzhambu': require('../../assets/dishes/card/kara-kuzhambu.webp'),
  'mor-kuzhambu': require('../../assets/dishes/card/mor-kuzhambu.webp'),
  'vendakai-puli-kuzhambu': require('../../assets/dishes/card/vendakai-puli-kuzhambu.webp'),
  'ennai-kathirikai-kuzhambu': require('../../assets/dishes/card/ennai-kathirikai-kuzhambu.webp'),
  'beans-poriyal': require('../../assets/dishes/card/beans-poriyal.webp'),
  'carrot-poriyal': require('../../assets/dishes/card/carrot-poriyal.webp'),
  'snake-gourd-poriyal': require('../../assets/dishes/card/snake-gourd-poriyal.webp'),
  'cluster-beans-poriyal': require('../../assets/dishes/card/cluster-beans-poriyal.webp'),
  'raw-banana-poriyal': require('../../assets/dishes/card/raw-banana-poriyal.webp'),
  'chow-chow-poriyal': require('../../assets/dishes/card/chow-chow-poriyal.webp'),
  'ridge-gourd-poriyal': require('../../assets/dishes/card/ridge-gourd-poriyal.webp'),
  'plantain-poriyal': require('../../assets/dishes/card/plantain-poriyal.webp'),
  'chow-chow-kootu': require('../../assets/dishes/card/chow-chow-kootu.webp'),
  'cabbage-kootu': require('../../assets/dishes/card/cabbage-kootu.webp'),
  'snake-gourd-kootu': require('../../assets/dishes/card/snake-gourd-kootu.webp'),
  'bottle-gourd-kootu': require('../../assets/dishes/card/bottle-gourd-kootu.webp'),
  'keerai-kootu': require('../../assets/dishes/card/keerai-kootu.webp'),
  'ash-gourd-kootu': require('../../assets/dishes/card/ash-gourd-kootu.webp'),
  'mixed-veg-kootu': require('../../assets/dishes/card/mixed-veg-kootu.webp'),
  'cabbage-thoran': require('../../assets/dishes/card/cabbage-thoran.webp'),
  'beans-thoran': require('../../assets/dishes/card/beans-thoran.webp'),
  'carrot-thoran': require('../../assets/dishes/card/carrot-thoran.webp'),
  'beetroot-thoran': require('../../assets/dishes/card/beetroot-thoran.webp'),
  olan: require('../../assets/dishes/card/olan.webp'),
  erissery: require('../../assets/dishes/card/erissery.webp'),
  kalan: require('../../assets/dishes/card/kalan.webp'),
  pulissery: require('../../assets/dishes/card/pulissery.webp'),
  'dosakaya-pappu': require('../../assets/dishes/card/dosakaya-pappu.webp'),
  'gongura-pappu': require('../../assets/dishes/card/gongura-pappu.webp'),
  'tomato-pulusu': require('../../assets/dishes/card/tomato-pulusu.webp'),
  'bendakaya-vepudu': require('../../assets/dishes/card/bendakaya-vepudu.webp'),
  'aratikaya-vepudu': require('../../assets/dishes/card/aratikaya-vepudu.webp'),
  'gutti-vankaya': require('../../assets/dishes/card/gutti-vankaya.webp'),
  'tomato-pachadi': require('../../assets/dishes/card/tomato-pachadi.webp'),
  'vankaya-pachadi': require('../../assets/dishes/card/vankaya-pachadi.webp'),
  'vegetable-huli': require('../../assets/dishes/card/vegetable-huli.webp'),
  'cabbage-palya': require('../../assets/dishes/card/cabbage-palya.webp'),
  'beans-palya': require('../../assets/dishes/card/beans-palya.webp'),
  'tomato-gojju': require('../../assets/dishes/card/tomato-gojju.webp'),
  'majjige-huli': require('../../assets/dishes/card/majjige-huli.webp'),
  'badanekai-ennegai': require('../../assets/dishes/card/badanekai-ennegai.webp'),
  'rava-idli': require('../../assets/dishes/card/rava-idli.webp'),
  'kanchipuram-idli': require('../../assets/dishes/card/kanchipuram-idli.webp'),
  'rava-dosa': require('../../assets/dishes/card/rava-dosa.webp'),
  'set-dosa': require('../../assets/dishes/card/set-dosa.webp'),
  'onion-dosa': require('../../assets/dishes/card/onion-dosa.webp'),
  'neer-dosa': require('../../assets/dishes/card/neer-dosa.webp'),
  pesarattu: require('../../assets/dishes/card/pesarattu.webp'),
  adai: require('../../assets/dishes/card/adai.webp'),
  'onion-uttapam': require('../../assets/dishes/card/onion-uttapam.webp'),
  'ven-pongal': require('../../assets/dishes/card/ven-pongal.webp'),
  'khara-pongal': require('../../assets/dishes/card/khara-pongal.webp'),
  'khara-bath': require('../../assets/dishes/card/khara-bath.webp'),
  'kesari-bath': require('../../assets/dishes/card/kesari-bath.webp'),
  'kara-paniyaram': require('../../assets/dishes/card/kara-paniyaram.webp'),
  appam: require('../../assets/dishes/card/appam.webp'),
  idiyappam: require('../../assets/dishes/card/idiyappam.webp'),
  puttu: require('../../assets/dishes/card/puttu.webp'),
  'medu-vada': require('../../assets/dishes/card/medu-vada.webp'),
  'masala-vada': require('../../assets/dishes/card/masala-vada.webp'),
  'lemon-sevai': require('../../assets/dishes/card/lemon-sevai.webp'),
  'rava-kichadi': require('../../assets/dishes/card/rava-kichadi.webp'),
  puliyogare: require('../../assets/dishes/card/puliyogare.webp'),
  'mint-rice': require('../../assets/dishes/card/mint-rice.webp'),
  'ellu-sadam': require('../../assets/dishes/card/ellu-sadam.webp'),
  'idli-podi-rice': require('../../assets/dishes/card/idli-podi-rice.webp'),
  'chettinad-chicken': require('../../assets/dishes/card/chettinad-chicken.webp'),
  'kongunad-chicken': require('../../assets/dishes/card/kongunad-chicken.webp'),
  'meen-kuzhambu': require('../../assets/dishes/card/meen-kuzhambu.webp'),
  'eral-varuval': require('../../assets/dishes/card/eral-varuval.webp'),
  'nadan-egg-roast': require('../../assets/dishes/card/nadan-egg-roast.webp'),
  'nattu-kozhi-kuzhambu': require('../../assets/dishes/card/nattu-kozhi-kuzhambu.webp'),
  'mutton-chukka': require('../../assets/dishes/card/mutton-chukka.webp'),
  'meen-varuval': require('../../assets/dishes/card/meen-varuval.webp'),
  bassaru: require('../../assets/dishes/card/bassaru.webp'),
  'keerai-masiyal': require('../../assets/dishes/card/keerai-masiyal.webp'),
  'kadala-curry': require('../../assets/dishes/card/kadala-curry.webp'),
  'more-rasam': require('../../assets/dishes/card/more-rasam.webp'),
  'masoor-dal': require('../../assets/dishes/card/masoor-dal.webp'),
  'masoor-dal-palak': require('../../assets/dishes/card/masoor-dal-palak.webp'),
  'dal-palak': require('../../assets/dishes/card/dal-palak.webp'),
  'dhaba-dal': require('../../assets/dishes/card/dhaba-dal.webp'),
  'dal-fry-restaurant-style': require('../../assets/dishes/card/dal-fry-restaurant-style.webp'),
  'urad-dal-maa-ki-dal': require('../../assets/dishes/card/urad-dal-maa-ki-dal.webp'),
  'sookhi-urad-dal': require('../../assets/dishes/card/sookhi-urad-dal.webp'),
  'chana-dal': require('../../assets/dishes/card/chana-dal.webp'),
  'chana-dal-lauki': require('../../assets/dishes/card/chana-dal-lauki.webp'),
  'moong-masoor-dal': require('../../assets/dishes/card/moong-masoor-dal.webp'),
  'dal-dhokli': require('../../assets/dishes/card/dal-dhokli.webp'),
  'gujarati-dal': require('../../assets/dishes/card/gujarati-dal.webp'),
  'sambhar-style-dal': require('../../assets/dishes/card/sambhar-style-dal.webp'),
  varan: require('../../assets/dishes/card/varan.webp'),
  amti: require('../../assets/dishes/card/amti.webp'),
  'khatti-dal': require('../../assets/dishes/card/khatti-dal.webp'),
  pithla: require('../../assets/dishes/card/pithla.webp'),
  zunka: require('../../assets/dishes/card/zunka.webp'),
  'green-moong-sprouts-curry': require('../../assets/dishes/card/green-moong-sprouts-curry.webp'),
  'mixed-sprouts-usal': require('../../assets/dishes/card/mixed-sprouts-usal.webp'),
  'kala-chana-curry': require('../../assets/dishes/card/kala-chana-curry.webp'),
  'pindi-chole': require('../../assets/dishes/card/pindi-chole.webp'),
  'amritsari-chole': require('../../assets/dishes/card/amritsari-chole.webp'),
  'chole-palak': require('../../assets/dishes/card/chole-palak.webp'),
  'rajma-chawal-plate': require('../../assets/dishes/card/rajma-chawal-plate.webp'),
  'kala-chana-sundal': require('../../assets/dishes/card/kala-chana-sundal.webp'),
  'vatana-usal': require('../../assets/dishes/card/vatana-usal.webp'),
  'matki-usal': require('../../assets/dishes/card/matki-usal.webp'),
  'moth-bean-curry': require('../../assets/dishes/card/moth-bean-curry.webp'),
  'kulith-saaru': require('../../assets/dishes/card/kulith-saaru.webp'),
  'dal-baati': require('../../assets/dishes/card/dal-baati.webp'),
  'langar-wali-dal': require('../../assets/dishes/card/langar-wali-dal.webp'),
  'gujarati-kadhi': require('../../assets/dishes/card/gujarati-kadhi.webp'),
  'pakora-kadhi': require('../../assets/dishes/card/pakora-kadhi.webp'),
  'sindhi-kadhi': require('../../assets/dishes/card/sindhi-kadhi.webp'),
  'boondi-kadhi': require('../../assets/dishes/card/boondi-kadhi.webp'),
  'dahi-kadhi': require('../../assets/dishes/card/dahi-kadhi.webp'),
  'jeera-rice': require('../../assets/dishes/card/jeera-rice.webp'),
  'ghee-rice': require('../../assets/dishes/card/ghee-rice.webp'),
  'matar-pulao': require('../../assets/dishes/card/matar-pulao.webp'),
  'paneer-pulao': require('../../assets/dishes/card/paneer-pulao.webp'),
  'mushroom-pulao': require('../../assets/dishes/card/mushroom-pulao.webp'),
  'kashmiri-pulao': require('../../assets/dishes/card/kashmiri-pulao.webp'),
  'hyderabadi-veg-biryani': require('../../assets/dishes/card/hyderabadi-veg-biryani.webp'),
  'bagara-rice': require('../../assets/dishes/card/bagara-rice.webp'),
  'methi-rice': require('../../assets/dishes/card/methi-rice.webp'),
  'palak-rice': require('../../assets/dishes/card/palak-rice.webp'),
  'coconut-rice': require('../../assets/dishes/card/coconut-rice.webp'),
  'tamarind-rice': require('../../assets/dishes/card/tamarind-rice.webp'),
  'dal-khichdi': require('../../assets/dishes/card/dal-khichdi.webp'),
  'vegetable-khichdi': require('../../assets/dishes/card/vegetable-khichdi.webp'),
  'bajra-khichdi': require('../../assets/dishes/card/bajra-khichdi.webp'),
  'masala-bhaat': require('../../assets/dishes/card/masala-bhaat.webp'),
  'vangi-bhaat': require('../../assets/dishes/card/vangi-bhaat.webp'),
  chitranna: require('../../assets/dishes/card/chitranna.webp'),
  'dal-rice-plate': require('../../assets/dishes/card/dal-rice-plate.webp'),
  'kadhi-chawal': require('../../assets/dishes/card/kadhi-chawal.webp'),
  'dal-lasooni': require('../../assets/dishes/card/dal-lasooni.webp'),
  'chana-dal-palak': require('../../assets/dishes/card/chana-dal-palak.webp'),
  'moong-dal-tadka': require('../../assets/dishes/card/moong-dal-tadka.webp'),
  'green-moong-dal': require('../../assets/dishes/card/green-moong-dal.webp'),
  'kabuli-chana-curry': require('../../assets/dishes/card/kabuli-chana-curry.webp'),
  dalma: require('../../assets/dishes/card/dalma.webp'),
  'sabut-masoor-dal': require('../../assets/dishes/card/sabut-masoor-dal.webp'),
  'dhuli-urad-dal': require('../../assets/dishes/card/dhuli-urad-dal.webp'),
  'mango-dal': require('../../assets/dishes/card/mango-dal.webp'),
  'tomato-pappu': require('../../assets/dishes/card/tomato-pappu.webp'),
  'palakura-pappu': require('../../assets/dishes/card/palakura-pappu.webp'),
  'saunf-wali-dal': require('../../assets/dishes/card/saunf-wali-dal.webp'),
  'oats-khichdi': require('../../assets/dishes/card/oats-khichdi.webp'),
  'corn-pulao': require('../../assets/dishes/card/corn-pulao.webp'),
  'soya-pulao': require('../../assets/dishes/card/soya-pulao.webp'),
  'masoor-pulao': require('../../assets/dishes/card/masoor-pulao.webp'),
  'sprouts-pulao': require('../../assets/dishes/card/sprouts-pulao.webp'),
  'bhuni-moong-dal-khichuri': require('../../assets/dishes/card/bhuni-moong-dal-khichuri.webp'),
  'plain-roti': require('../../assets/dishes/card/plain-roti.webp'),
  chapati: require('../../assets/dishes/card/chapati.webp'),
  phulka: require('../../assets/dishes/card/phulka.webp'),
  'tawa-paratha': require('../../assets/dishes/card/tawa-paratha.webp'),
  'lachha-paratha': require('../../assets/dishes/card/lachha-paratha.webp'),
  bhatura: require('../../assets/dishes/card/bhatura.webp'),
  poori: require('../../assets/dishes/card/poori.webp'),
  'missi-roti': require('../../assets/dishes/card/missi-roti.webp'),
  'makki-di-roti': require('../../assets/dishes/card/makki-di-roti.webp'),
  'bajra-roti': require('../../assets/dishes/card/bajra-roti.webp'),
  'jowar-bhakri': require('../../assets/dishes/card/jowar-bhakri.webp'),
  'ragi-roti': require('../../assets/dishes/card/ragi-roti.webp'),
  'gobi-paratha': require('../../assets/dishes/card/gobi-paratha.webp'),
  'mooli-paratha': require('../../assets/dishes/card/mooli-paratha.webp'),
  'onion-paratha': require('../../assets/dishes/card/onion-paratha.webp'),
  'thepla-plain': require('../../assets/dishes/card/thepla-plain.webp'),
  'dal-paratha': require('../../assets/dishes/card/dal-paratha.webp'),
  'sattu-paratha': require('../../assets/dishes/card/sattu-paratha.webp'),
  'mix-veg-paratha': require('../../assets/dishes/card/mix-veg-paratha.webp'),
  'beetroot-paratha': require('../../assets/dishes/card/beetroot-paratha.webp'),
  'palak-paratha': require('../../assets/dishes/card/palak-paratha.webp'),
  'cheese-paratha': require('../../assets/dishes/card/cheese-paratha.webp'),
  'kanda-poha': require('../../assets/dishes/card/kanda-poha.webp'),
  'batata-poha': require('../../assets/dishes/card/batata-poha.webp'),
  'aloo-poha': require('../../assets/dishes/card/aloo-poha.webp'),
  'vegetable-upma': require('../../assets/dishes/card/vegetable-upma.webp'),
  'moong-dal-chilla': require('../../assets/dishes/card/moong-dal-chilla.webp'),
  'vegetable-chilla': require('../../assets/dishes/card/vegetable-chilla.webp'),
  'bread-upma': require('../../assets/dishes/card/bread-upma.webp'),
  'vermicelli-upma': require('../../assets/dishes/card/vermicelli-upma.webp'),
  'sabudana-vada': require('../../assets/dishes/card/sabudana-vada.webp'),
  'dalia-porridge': require('../../assets/dishes/card/dalia-porridge.webp'),
  'oats-porridge': require('../../assets/dishes/card/oats-porridge.webp'),
  'masala-oats': require('../../assets/dishes/card/masala-oats.webp'),
  'vegetable-daliya': require('../../assets/dishes/card/vegetable-daliya.webp'),
  'cornflakes-bowl': require('../../assets/dishes/card/cornflakes-bowl.webp'),
  'muesli-bowl': require('../../assets/dishes/card/muesli-bowl.webp'),
  'fruit-bowl': require('../../assets/dishes/card/fruit-bowl.webp'),
  'poori-bhaji': require('../../assets/dishes/card/poori-bhaji.webp'),
  'chole-bhature-plate': require('../../assets/dishes/card/chole-bhature-plate.webp'),
  'sprouts-salad': require('../../assets/dishes/card/sprouts-salad.webp'),
  'moong-sprouts-bhel': require('../../assets/dishes/card/moong-sprouts-bhel.webp'),
  'ragi-mudde': require('../../assets/dishes/card/ragi-mudde.webp'),
  'ragi-malt': require('../../assets/dishes/card/ragi-malt.webp'),
  'aloo-tikki-breakfast': require('../../assets/dishes/card/aloo-tikki-breakfast.webp'),
  'aloo-tikki': require('../../assets/dishes/card/aloo-tikki.webp'),
  'onion-pakora': require('../../assets/dishes/card/onion-pakora.webp'),
  'potato-pakora': require('../../assets/dishes/card/potato-pakora.webp'),
  'palak-pakora': require('../../assets/dishes/card/palak-pakora.webp'),
  'mirchi-bhajiya': require('../../assets/dishes/card/mirchi-bhajiya.webp'),
  'bread-pakora': require('../../assets/dishes/card/bread-pakora.webp'),
  'masala-maggi': require('../../assets/dishes/card/masala-maggi.webp'),
  'corn-chaat': require('../../assets/dishes/card/corn-chaat.webp'),
  'peanut-chaat': require('../../assets/dishes/card/peanut-chaat.webp'),
  'masala-papad': require('../../assets/dishes/card/masala-papad.webp'),
  'white-dhokla': require('../../assets/dishes/card/white-dhokla.webp'),
  'rava-dhokla': require('../../assets/dishes/card/rava-dhokla.webp'),
  handvo: require('../../assets/dishes/card/handvo.webp'),
  muthia: require('../../assets/dishes/card/muthia.webp'),
  fafda: require('../../assets/dishes/card/fafda.webp'),
  khandvi: require('../../assets/dishes/card/khandvi.webp'),
  patra: require('../../assets/dishes/card/patra.webp'),
  'methi-puri': require('../../assets/dishes/card/methi-puri.webp'),
  'sweet-corn-fritters': require('../../assets/dishes/card/sweet-corn-fritters.webp'),
  'besan-toast': require('../../assets/dishes/card/besan-toast.webp'),
  'poha-cutlet': require('../../assets/dishes/card/poha-cutlet.webp'),
  'sabudana-thalipeeth': require('../../assets/dishes/card/sabudana-thalipeeth.webp'),
  thalipeeth: require('../../assets/dishes/card/thalipeeth.webp'),
  'rava-toast': require('../../assets/dishes/card/rava-toast.webp'),
  'aloo-bonda': require('../../assets/dishes/card/aloo-bonda.webp'),
  'mysore-bonda': require('../../assets/dishes/card/mysore-bonda.webp'),
  'chana-chaat': require('../../assets/dishes/card/chana-chaat.webp'),
  'paneer-tikka-masala': require('../../assets/dishes/card/paneer-tikka-masala.webp'),
  'shahi-paneer': require('../../assets/dishes/card/shahi-paneer.webp'),
  'paneer-lababdar': require('../../assets/dishes/card/paneer-lababdar.webp'),
  'paneer-do-pyaza': require('../../assets/dishes/card/paneer-do-pyaza.webp'),
  'paneer-korma': require('../../assets/dishes/card/paneer-korma.webp'),
  'methi-paneer': require('../../assets/dishes/card/methi-paneer.webp'),
  'achari-paneer': require('../../assets/dishes/card/achari-paneer.webp'),
  'paneer-pasanda': require('../../assets/dishes/card/paneer-pasanda.webp'),
  'paneer-makhani': require('../../assets/dishes/card/paneer-makhani.webp'),
  'saag-paneer': require('../../assets/dishes/card/saag-paneer.webp'),
  'paneer-kofta': require('../../assets/dishes/card/paneer-kofta.webp'),
  'paneer-capsicum': require('../../assets/dishes/card/paneer-capsicum.webp'),
  'paneer-roll': require('../../assets/dishes/card/paneer-roll.webp'),
  'tofu-bhurji': require('../../assets/dishes/card/tofu-bhurji.webp'),
  'tofu-stir-fry': require('../../assets/dishes/card/tofu-stir-fry.webp'),
  'tofu-curry': require('../../assets/dishes/card/tofu-curry.webp'),
  'palak-tofu': require('../../assets/dishes/card/palak-tofu.webp'),
  'egg-masala': require('../../assets/dishes/card/egg-masala.webp'),
  'anda-masala': require('../../assets/dishes/card/anda-masala.webp'),
  'masala-omelette': require('../../assets/dishes/card/masala-omelette.webp'),
  'egg-drop-curry': require('../../assets/dishes/card/egg-drop-curry.webp'),
  'dim-curry': require('../../assets/dishes/card/dim-curry.webp'),
  'egg-kurma': require('../../assets/dishes/card/egg-kurma.webp'),
  'scrambled-eggs': require('../../assets/dishes/card/scrambled-eggs.webp'),
  'boiled-egg-sabzi': require('../../assets/dishes/card/boiled-egg-sabzi.webp'),
  'egg-ghotala': require('../../assets/dishes/card/egg-ghotala.webp'),
  'half-fry': require('../../assets/dishes/card/half-fry.webp'),
  'egg-biryani': require('../../assets/dishes/card/egg-biryani.webp'),
  'egg-pulao': require('../../assets/dishes/card/egg-pulao.webp'),
  'chicken-masala': require('../../assets/dishes/card/chicken-masala.webp'),
  'butter-chicken': require('../../assets/dishes/card/butter-chicken.webp'),
  'chicken-tikka-masala': require('../../assets/dishes/card/chicken-tikka-masala.webp'),
  'kadai-chicken': require('../../assets/dishes/card/kadai-chicken.webp'),
  'chicken-korma': require('../../assets/dishes/card/chicken-korma.webp'),
  'chicken-do-pyaza': require('../../assets/dishes/card/chicken-do-pyaza.webp'),
  'chicken-bhuna': require('../../assets/dishes/card/chicken-bhuna.webp'),
  'methi-chicken': require('../../assets/dishes/card/methi-chicken.webp'),
  'palak-chicken': require('../../assets/dishes/card/palak-chicken.webp'),
  'chicken-pulao': require('../../assets/dishes/card/chicken-pulao.webp'),
  'chicken-65': require('../../assets/dishes/card/chicken-65.webp'),
  'chicken-fry': require('../../assets/dishes/card/chicken-fry.webp'),
  'pepper-chicken': require('../../assets/dishes/card/pepper-chicken.webp'),
  'ginger-chicken': require('../../assets/dishes/card/ginger-chicken.webp'),
  'chicken-stew': require('../../assets/dishes/card/chicken-stew.webp'),
  'chicken-kheema': require('../../assets/dishes/card/chicken-kheema.webp'),
  'dahi-chicken': require('../../assets/dishes/card/dahi-chicken.webp'),
  'chicken-sukha': require('../../assets/dishes/card/chicken-sukha.webp'),
  'chicken-handi': require('../../assets/dishes/card/chicken-handi.webp'),
  'mutton-curry': require('../../assets/dishes/card/mutton-curry.webp'),
  'mutton-korma': require('../../assets/dishes/card/mutton-korma.webp'),
  'mutton-keema': require('../../assets/dishes/card/mutton-keema.webp'),
  'keema-matar': require('../../assets/dishes/card/keema-matar.webp'),
  'mutton-biryani': require('../../assets/dishes/card/mutton-biryani.webp'),
  'mutton-sukha': require('../../assets/dishes/card/mutton-sukha.webp'),
  'mutton-masala': require('../../assets/dishes/card/mutton-masala.webp'),
  'bhuna-gosht': require('../../assets/dishes/card/bhuna-gosht.webp'),
  'mutton-do-pyaza': require('../../assets/dishes/card/mutton-do-pyaza.webp'),
  'fish-curry': require('../../assets/dishes/card/fish-curry.webp'),
  'fish-masala': require('../../assets/dishes/card/fish-masala.webp'),
  'machher-jhol': require('../../assets/dishes/card/machher-jhol.webp'),
  'goan-fish-curry': require('../../assets/dishes/card/goan-fish-curry.webp'),
  'prawn-curry': require('../../assets/dishes/card/prawn-curry.webp'),
  'prawn-masala': require('../../assets/dishes/card/prawn-masala.webp'),
  'prawn-biryani': require('../../assets/dishes/card/prawn-biryani.webp'),
  'fish-biryani': require('../../assets/dishes/card/fish-biryani.webp'),
  'crab-masala': require('../../assets/dishes/card/crab-masala.webp'),
  'veg-manchow-soup': require('../../assets/dishes/card/veg-manchow-soup.webp'),
  'hot-and-sour-soup': require('../../assets/dishes/card/hot-and-sour-soup.webp'),
  'sweet-corn-soup': require('../../assets/dishes/card/sweet-corn-soup.webp'),
  'grilled-vegetables': require('../../assets/dishes/card/grilled-vegetables.webp'),
  'mushroom-soup': require('../../assets/dishes/card/mushroom-soup.webp'),
  'tomato-soup': require('../../assets/dishes/card/tomato-soup.webp'),
  'minestrone-soup': require('../../assets/dishes/card/minestrone-soup.webp'),
  'green-salad': require('../../assets/dishes/card/green-salad.webp'),
  'kachumber-salad': require('../../assets/dishes/card/kachumber-salad.webp'),
  'fruit-salad': require('../../assets/dishes/card/fruit-salad.webp'),
  'corn-salad': require('../../assets/dishes/card/corn-salad.webp'),
  'chickpea-salad': require('../../assets/dishes/card/chickpea-salad.webp'),
  'pasta-salad': require('../../assets/dishes/card/pasta-salad.webp'),
  'caesar-salad': require('../../assets/dishes/card/caesar-salad.webp'),
  'greek-salad': require('../../assets/dishes/card/greek-salad.webp'),
  'quinoa-salad': require('../../assets/dishes/card/quinoa-salad.webp'),
  'boondi-raita': require('../../assets/dishes/card/boondi-raita.webp'),
  'cucumber-raita': require('../../assets/dishes/card/cucumber-raita.webp'),
  'mixed-veg-raita': require('../../assets/dishes/card/mixed-veg-raita.webp'),
  'suji-halwa': require('../../assets/dishes/card/suji-halwa.webp'),
  'moong-dal-halwa': require('../../assets/dishes/card/moong-dal-halwa.webp'),
  payasam: require('../../assets/dishes/card/payasam.webp'),
  'sevai-kheer': require('../../assets/dishes/card/sevai-kheer.webp'),
  'sabudana-kheer': require('../../assets/dishes/card/sabudana-kheer.webp'),
  phirni: require('../../assets/dishes/card/phirni.webp'),
  kulfi: require('../../assets/dishes/card/kulfi.webp'),
  'fruit-custard': require('../../assets/dishes/card/fruit-custard.webp'),
  'fruit-cream': require('../../assets/dishes/card/fruit-cream.webp'),
  modak: require('../../assets/dishes/card/modak.webp'),
  'puran-poli': require('../../assets/dishes/card/puran-poli.webp'),
  'atte-ka-halwa': require('../../assets/dishes/card/atte-ka-halwa.webp'),
  'lauki-halwa': require('../../assets/dishes/card/lauki-halwa.webp'),
  'beetroot-halwa': require('../../assets/dishes/card/beetroot-halwa.webp'),
  'plain-naan': require('../../assets/dishes/card/plain-naan.webp'),
  'plain-bhakri': require('../../assets/dishes/card/plain-bhakri.webp'),
  baati: require('../../assets/dishes/card/baati.webp'),
  luchi: require('../../assets/dishes/card/luchi.webp'),
  kachori: require('../../assets/dishes/card/kachori.webp'),
  'mirchi-ka-salan': require('../../assets/dishes/card/mirchi-ka-salan.webp'),
  thecha: require('../../assets/dishes/card/thecha.webp'),
  'veg-manchurian': require('../../assets/dishes/card/veg-manchurian.webp'),
  'spring-rolls': require('../../assets/dishes/card/spring-rolls.webp'),
  'plain-kulcha': require('../../assets/dishes/card/plain-kulcha.webp'),
  'chilli-chicken': require('../../assets/dishes/card/chilli-chicken.webp'),
  falooda: require('../../assets/dishes/card/falooda.webp'),
  'masala-chai': require('../../assets/dishes/card/masala-chai.webp'),
};
